import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import {
  c1,
  MENU_BUTTON_CODE,
  MENU_BUTTON_STYLE,
} from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MenuButton, Tab } from "src/app/core/services/interface";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { WebsocketService } from "src/app/core/services/websocket.service";
import { BuilderService } from "src/app/sharedservices/builder.service";

@Component({
  selector: "app-button-voice-recorder",
  templateUrl: "./button-voice-recorder.component.html",
  styleUrls: ["./button-voice-recorder.component.scss"],
})
export class ButtonVoiceRecorderComponent implements OnInit, OnDestroy {
  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    public indexDBService: IndexDBService,
    public builderService: BuilderService,
  ) {}

  @Input() button: MenuButton;
  @Input() fontSmaller = false;
  @Input() mode: string;
  @Input() fontResize = false;
  @Input() row_id: string;
  @Input() data: Tab;
  @Input() colors: any;
  @Input() no_buttons = 1;

  //////////////////// what have been used //////////////
  currentMenuSubscription: any;
  updateBuilderComponentSubscription: any;
  colorsComponentSubscription: any;
  offCanvasSubscription: any;
  border_color: string;
  card_round: string;
  sec_round: string;

  bg_image: string = null;
  bg_color: string = null; // = "#000000";;
  start_color: string = null; // = "#1be6e2";
  end_color: string = null; //= "#1be6e2";
  image: string = null;
  album_button: any;
  albums: any;
  emptyImage: string;
  emptyImageP0: string;
  emptyImageP1: string;
  widthP0: string;
  styleP0: number = 1;
  styleP1: number = 1;
  label: string;
  sublable: string;
  label_color: string;
  sublabel_color: string;
  body_color: string;
  settings: any;
  body: string;
  transparent: boolean = false;
  /////
  isAndroid: boolean;
  current_button: any;
  isActive: boolean;
  light: boolean = true;
  color_schema: any;
  color_schema_ios: any;
  label_align: string;
  sublabel_align: string;
  body_align: string;
  label_size: string;
  sublabel_size: string;
  body_size: string;

  textAlign: any = {};
  textFontsize: any = {};
  outlined: boolean;
  elevated: boolean;
  filled: boolean;
  shadow: boolean;
  surfaceColor: string;
  trailing_icon: string = null;
  trailing_icon_color: string;
  trailing_text_color: string;

  leading_icon: string;
  leading_icon_color: string;
  placeHolderBG: string;

  ngOnInit() {
    let style = this.isAndroid
      ? this.button.button_style
      : this.button.button_style_ios;
    this.initialize(this.button.button_style, this.no_buttons);

    this.currentMenuSubscription = this.mdw.currentMenuContainer$.subscribe(
      (data) => {
        if (data && !data.fromButton) {
          if (data["sortedButtonList"][this.row_id]) {
            this.no_buttons =
              data["sortedButtonList"][this.row_id].length > 0
                ? data["sortedButtonList"][this.row_id].length
                : 1;
            this.current_button = data["currentButton"];
            this.isActive =
              this.current_button &&
              this.current_button.button_id == this.button.button_id
                ? true
                : false;

            let style = this.isAndroid
              ? this.button.button_style
              : this.button.button_style_ios;
            this.initialize(style, this.no_buttons);
          }
        }
      },
    );

    this.colorsComponentSubscription =
      this.mdw.colorsComponentContainer$.subscribe((data) => {
        if (
          data &&
          data.color_schema &&
          data.color_schema_ios &&
          data.light != null
        ) {
          this.colors = data;
          this.light = data.light;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      });

    this.offCanvasSubscription = this.mdw.offCanvasContainer$.subscribe(
      (data) => {
        // only for getting default button to change style for active or none active button style

        if (data && data.button) {
          this.current_button = data.button;
          this.isActive =
            this.current_button &&
            this.current_button.button_id == this.button.button_id
              ? true
              : false;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      },
    );

    this.updateBuilderComponentSubscription =
      this.mdw.updateBuilderComponentContainer$.subscribe((data) => {
        if (data && data.tab) {
          // only to get different views for button for Android and iOS. if both same view we do not need this subscription.

          this.isAndroid =
            localStorage.getItem("mode")[0] == c1.ANDROID ? true : false;
          let style = this.isAndroid
            ? this.button.button_style
            : this.button.button_style_ios;
          this.initialize(style, this.no_buttons);
        }
      });
  }

  initialize(style, no_button) {
    this.isAndroid =
      localStorage.getItem("mode")[0] === c1.ANDROID ? true : false;
    if (this.colors && this.button) {
      this.color_schema = this.light
        ? this.colors.color_schema.schemes.light
        : this.colors.color_schema.schemes.dark;
      this.color_schema_ios = this.light
        ? this.colors.color_schema_ios.schemes.light
        : this.colors.color_schema_ios.schemes.dark;
    }
    // Theme Settings
    // style configuration params
    //convert the dropmenu style to same button-input style to standardize the code.
    let drop_style = this.convertStyle(style);
    this.album_button = album_button_map[drop_style];
    this.albums = this.album_button.albums;
    this.emptyImage = this.album_button.emptyFullImage[no_button];
    // this.settings = this.album_button.settings;
    this.settings = this.album_button.settings;
    this.card_round = this.album_button.card_round;
    this.sec_round = this.album_button.sec_round;

    this.emptyImageP0 = this.albums[0].emptyImage[no_button];
    this.emptyImageP1 = this.albums[1].emptyImage[no_button];
    this.widthP0 = this.albums[0].width[no_button];

    this.textAlign = this.isAndroid
      ? this.button.button_text_align
      : this.button.button_text_align_ios;
    this.textFontsize = this.isAndroid
      ? this.button.button_text_fontsize
      : this.button.button_text_fontsize_ios;
    this.border_color = this.builderService.buttonColor(
      this.button.button_color_schema,
      this.colors.color_schema,
      "outline",
      "outline",
      this.light,
    );

    this.surfaceColor = this.isAndroid
      ? this.builderService.buttonColor(
          null,
          this.colors.color_schema,
          null,
          "surface",
          this.light,
        )
      : this.builderService.buttonColor(
          null,
          this.colors.color_schema_ios,
          null,
          "surface",
          this.light,
        );
    this.themeColors(drop_style);
    this.cardStyle(style);
  }

  themeColors(style) {
    switch (style) {
      case MENU_BUTTON_STYLE?.STYLE_02:
        this.image = null;
        this.bg_image = null;
        this.bg_color = null;
        this.styleP1 = 0;

        this.label = this.button.button_headline;
        this.leading_icon = this.isAndroid ? this.button.button_icon : this.button.button_icon_ios;
        this.trailing_icon = this.isAndroid ? this.button.button_trailing_icon : this.button.button_trailing_icon_ios;
        this.leading_icon_color= this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, "noChange", "surfaceContainerLowest", this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios,this.colors.color_schema_ios,"noChange","surfaceContainerLowest",this.light);
        this.placeHolderBG= this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, "noChange", "outlineVariant", this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios,this.colors.color_schema_ios,"noChange","outlineVariant",this.light);
        this.body = null;

        this.start_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bgstart",
              "primaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bgstart",
              "primaryContainer",
              this.light,
            );

        this.end_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bgend",
              "primaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bgend",
              "primaryContainer",
              this.light,
            );

        this.label_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "headline",
              "onPrimaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "headline",
              "onPrimaryContainer",
              this.light,
            );

        this.sublabel_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "subhead",
              "onPrimaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "subhead",
              "onPrimaryContainer",
              this.light,
            );

        this.label_align =
          this.textAlign && this.textAlign.headline
            ? this.textAlign.headline
            : null;
        this.sublabel_align =
          this.textAlign && this.textAlign.subhead
            ? this.textAlign.subhead
            : null;
        this.body_align =
          this.textAlign && this.textAlign.body ? this.textAlign.body : null;

        break;

      case MENU_BUTTON_STYLE?.STYLE_01:
        this.image = null;
        this.bg_image = null;
        this.bg_color = null;
        this.styleP1 = 2;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.trailing_icon = this.isAndroid ? this.button.button_trailing_icon : this.button.button_trailing_icon_ios;
        this.leading_icon = this.isAndroid ? this.button.button_icon : this.button.button_icon_ios;
        this.leading_icon_color= this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, "noChange", "surfaceContainerLowest", this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios,this.colors.color_schema_ios,"noChange","surfaceContainerLowest",this.light);
        this.placeHolderBG= this.isAndroid ?
        this.builderService.buttonColor(this.button.button_color_schema, this.colors.color_schema, "noChange", "outlineVariant", this.light)
          : this.builderService.buttonColor(this.button.button_color_schema_ios,this.colors.color_schema_ios,"noChange","outlineVariant",this.light);
        this.body = null;


        this.start_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bgstart",
              "secondaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bgstart",
              "secondaryContainer",
              this.light,
            );

        this.end_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bgend",
              "secondaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bgend",
              "secondaryContainer",
              this.light,
            );

        this.label_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "headline",
              "onSecondaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "headline",
              "onSecondaryContainer",
              this.light,
            );

        this.sublabel_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "subhead",
              "onSecondaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "subhead",
              "onSecondaryContainer",
              this.light,
            );

        this.body_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "body",
              "onSecondaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "body",
              "onSecondaryContainer",
              this.light,
            );

        this.label_align =
          this.textAlign && this.textAlign.headline
            ? this.textAlign.headline
            : null;
        this.sublabel_align =
          this.textAlign && this.textAlign.subhead
            ? this.textAlign.subhead
            : null;

        break;
      case MENU_BUTTON_STYLE?.STYLE_03:
        this.image = null;
        this.bg_image = null;
        this.bg_color = null;
        this.styleP1 = 0;

        this.label = this.button.button_headline;
        this.sublable = this.button.button_subhead;
        this.body = this.button.button_body;

        this.start_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bgstart",
              "tertiaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bgstart",
              "tertiaryContainer",
              this.light,
            );

        this.end_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bgend",
              "tertiaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bgend",
              "tertiaryContainer",
              this.light,
            );

        this.label_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "headline",
              "onTertiaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "headline",
              "onTertiaryContainer",
              this.light,
            );

        this.sublabel_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "subhead",
              "onTertiaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "subhead",
              "onTertiaryContainer",
              this.light,
            );

        this.label_align =
          this.textAlign && this.textAlign.headline
            ? this.textAlign.headline
            : null;
        this.sublabel_align =
          this.textAlign && this.textAlign.subhead
            ? this.textAlign.subhead
            : null;
        this.body_align =
          this.textAlign && this.textAlign.body ? this.textAlign.body : null;

        this.body_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "body",
              "onSecondaryContainer",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "body",
              "onSecondaryContainer",
              this.light,
            );

        break;
    }
  }
  get setButtonBg() {
    if (this.bg_image) {
      this.transparent = false;
      return {
        "background-image": `url(${this.bg_image})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover",
      };
    } else if (this.start_color && this.end_color) {
      this.transparent = false;
      return {
        "background-image": `linear-gradient(180deg, ${this.start_color}, ${this.end_color})`,
      };
    } else if (this.bg_color) {
      this.transparent = false;
      return { background: this.bg_color };
    } else {
      this.transparent = true;
      // return { background: "unset" };
      return { background: this.surfaceColor };
    }
  }

  //fontSmalller for sideMobile
  // forntResize for Mobile View

  get lableColor() {
    return {
      color: this.label_color,
      // 'font-size': this.fontSmaller ? '5px' : (this.settings && this.settings.titleSize) ? this.settings.titleSize : '12px',
      "font-size": this.fontSmaller
        ? "5px"
        : this.fontResize
          ? this.fontScale("headline", "12px")
          : this.fontScale("headline", "16px"),
    };
  }

  get sublableColor() {
    return {
      color: this.sublabel_color,
      // 'font-size': this.fontSmaller ? '3px' : '9px',
      "font-size": this.fontSmaller
        ? "3px"
        : this.fontResize
          ? this.fontScale("subhead", "10px")
          : this.fontScale("subhead", "14px"),
    };
  }

  get bodyColor() {
    return {
      color: this.body_color,
      // 'font-size': this.fontSmaller ? '3px' : '9px',
      "font-size": this.fontSmaller
        ? "3px"
        : this.fontResize
          ? this.fontScale("body", "8px")
          : this.fontScale("body", "12px"),
    };
  }

  get leadingIconColor() {
    return {
      color: this.leading_icon_color,
      "font-size": this.fontSmaller ? "4px" : this.fontResize ? "12px" : "16px",
    };
  }

  get traillingIconColor() {
    return {
      color: "#000",
      "font-size": this.fontSmaller ? "4px" : this.fontResize ? "12px" : "16px",
    };
  }
  get traillingTextColor() {
    return {
      color: this.trailing_text_color,
      "font-size": this.fontSmaller ? "4px" : this.fontResize ? "12px" : "16px",
    };
  }

  get bgPlaceHolderColor() {
    return {
      'aspect-ratio': '1/1',
      'max-height': '65px',
      'background-color': this.placeHolderBG,
    };
  }

  fontScale(item, value) {
    let result: number;

    result = value.replace("px", "");

    // large is greater +2 and smaller is less -2
    if (this.textFontsize && this.textFontsize[item]) {
      switch (this.textFontsize[item]) {
        case "sm":
          result = Number(result) - 2;
          return result + "px";
          break;
        case "md":
          return Number(result) + "px";
          break;
        case "lg":
          result = Number(result) + 2;
          return result + "px";
          break;
      }
    } else {
      return value;
    }
  }

  convertStyle(style) {
    //x000 : old style
    //x   : old style
    //2nd : N/A   0: (some cells is divider)
    //3rd : card type
    // 0:elevated (shadow, no outline, bg),
    // 1: filled (no shadow, no outline and bg),
    // 2: outlined (no shadow, outline, bg)  //used to be boarder 1/0
    // 3: Custom
    // 4: transparent

    let cell_style = style.slice(0, 2);
    return cell_style;
  }

  cardStyle(style) {
    switch (Number(style[3])) {
      case 0:
        // elevated card
        this.outlined = false;
        this.shadow = true;
        this.start_color = null;
        this.end_color = null;
        this.bg_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bg",
              "surfaceContainerLow",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bg",
              "surfaceContainerLow",
              this.light,
            );
        break;
      case 1:
        // filled card
        this.outlined = false;
        this.shadow = false;
        this.start_color = null;
        this.end_color = null;
        this.bg_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bg",
              "surfaceContainerHighest",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bg",
              "surfaceContainerHighest",
              this.light,
            );
        break;

      case 2:
        // outlined card
        this.outlined = true;
        this.shadow = false;
        this.start_color = null;
        this.end_color = null;
        this.bg_color = this.isAndroid
          ? this.builderService.buttonColor(
              this.button.button_color_schema,
              this.colors.color_schema,
              "bg",
              "surface",
              this.light,
            )
          : this.builderService.buttonColor(
              this.button.button_color_schema_ios,
              this.colors.color_schema_ios,
              "bg",
              "surface",
              this.light,
            );

        break;

      case 4:
        this.outlined = false;
        this.shadow = false;
        this.start_color = null;
        this.end_color = null;
        this.bg_color = null;
        break;

      default:
        break;
    }
  }
  ngOnDestroy(): void {
    if (this.updateBuilderComponentSubscription) {
      this.updateBuilderComponentSubscription.unsubscribe();
    }
    if (this.currentMenuSubscription) {
      this.currentMenuSubscription.unsubscribe();
    }

    if (this.offCanvasSubscription) {
      this.offCanvasSubscription.unsubscribe();
    }

    if (this.colorsComponentSubscription) {
      this.colorsComponentSubscription.unsubscribe();
    }
  }
}

export const album_button_map = {
  // id = no. of button per row //
  [MENU_BUTTON_STYLE?.STYLE_02]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {},
        padding: "10px",
        opacity: 0,
        blur: "0px",
        round: "rounded-4",
        width: { 1: "90%", 2: "90%", 3: "90%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash8.webp",
          2: "./assets/images/mobile-2/splash8.webp",
          3: "./assets/images/mobile-3/splash8.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-4",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash8.webp",
      2: "./assets/images/mobile-2/splash8.webp",
      3: "./assets/images/mobile-3/splash8.webp",
    }, //100
  },
  [MENU_BUTTON_STYLE?.STYLE_01]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {},
        padding: "10px",
        opacity: 0,
        blur: "0px",
        round: "rounded-4",
        width: { 1: "90%", 2: "90%", 3: "90%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash8.webp",
          2: "./assets/images/mobile-2/splash8.webp",
          3: "./assets/images/mobile-3/splash8.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-4",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash8.webp",
      2: "./assets/images/mobile-2/splash8.webp",
      3: "./assets/images/mobile-3/splash8.webp",
    }, //100
  },
  [MENU_BUTTON_STYLE?.STYLE_03]: {
    albums: [
      {
        id: 0,
        en: false,
        emptyImage: {},
        padding: "10px",
        opacity: 0,
        blur: "0px",
        round: "rounded-4",
        width: { 1: "90%", 2: "90%", 3: "90%" },
      },
      {
        id: 1,
        en: true,
        emptyImage: {
          1: "./assets/images/mobile/splash20.webp",
          2: "./assets/images/mobile-2/splash20.webp",
          3: "./assets/images/mobile-3/splash20.webp",
        },
        padding: 0,
        opacity: 0,
        blur: "0px",
        round: "rounded-4",
      },
    ],
    emptyFullImage: {
      1: "./assets/images/mobile/splash20.webp",
      2: "./assets/images/mobile-2/splash20.webp",
      3: "./assets/images/mobile-3/splash20.webp",
    }, //100
  },
};
